import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=c56c9586&scoped=true&"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=c56c9586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56c9586",
  null
  
)

export default component.exports